/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Configuration } from '../../../Configuration';
import { RestServiceProvider } from '../../RestServiceProvider';
import { StatisticsService } from './StatisticsService';

class StatisticsServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new StatisticsService($q, resource, $httpParamSerialiserJQLike, $log);
    }

    getMetricsConfig(url) {
        return {
            url: url + Configuration.METRICS_PATH,
            method: 'POST',
            transformResponse:
                (data, headers, status) => ((status === 401) || (status === 403)) ? null : angular.fromJson(data)
        };
    }

    getChartDataConfig(url) {
        return {
            url: url + Configuration.CHART_DATA_PATH,
            method: 'POST',
            transformResponse:
                (data, headers, status) => ((status === 401) || (status === 403)) ? null : angular.fromJson(data)
        };
    }

    /** @ngInject */
    getConfig() {
        const config = super.getConfig();
        config.metrics = this.getMetricsConfig(this.resourceUrl);
        config.chartData = this.getChartDataConfig(this.resourceUrl);
        return config;
    }
}

export { StatisticsServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/statistics/service/StatisticsServiceProvider.js